import useApi from 'common/hooks/useApi';
import useThunkDispatch from 'common/hooks/useThunkDispatch';
import useTypedSelector from 'common/hooks/useTypedSelector';
import { finishSavingLicense } from 'features/profile-settings/ProfileSlice';
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { ProfileResponse } from './ProfileResponse';
import SharedHousingLicensePresenter from './SharedHousingLicensePresenter';

type ShuoLocationState = {
  onSuccess: {
    to: string;
    message: string;
    linkText: string;
  };
};

function SharedHousingLicenseContainer() {
  const { state } = useLocation<ShuoLocationState | undefined>();
  const dispatch = useThunkDispatch();

  const { licenseNumber } = useTypedSelector((state) => state.profile.data);
  const [apiState, updateLicenseNumber] = useApi<ProfileResponse>({
    url: '/profile/updateShuol',
    method: 'PUT',
  });

  const handleSubmit = async (values: Record<string, string>) => {
    updateLicenseNumber(values).then(({ data }) => {
      if (data?.licenseNumber) {
        dispatch(finishSavingLicense({ licenseNumber: data.licenseNumber }));
      }
    });
  };

  return (
    <>
      <SharedHousingLicensePresenter
        data={{ licenseNumber }}
        onSubmit={handleSubmit}
        error={apiState.error}
        success={Boolean(apiState.response?.ok)}
        saving={apiState.loading}
        successContent={
          state?.onSuccess ? (
            <>
              {state.onSuccess.message}{' '}
              <Link to={state.onSuccess.to} className='ml-2'>
                {state.onSuccess.linkText}
              </Link>
            </>
          ) : (
            "Successfully updated Operator's License"
          )
        }
      />
    </>
  );
}

export default SharedHousingLicenseContainer;
